import React, { useEffect, useState, useRef } from "react";
import {
    obtenerEmpleados,
    obtenerPuestos,
} from "./empleadosService";
import { showToast } from "../../utils/toast";

const ReconocimientoForm = ({
    data,
    onChange,
    tipoCarta,
    setTipoCarta,
    handleCheckboxChange,
    onPrint,
    generandoPDF,
}) => {
    const [empleados, setEmpleados] = useState([]);
    const [puestos, setPuestos] = useState([]);
    const [qEmpleado, setQEmpleado] = useState("");
    const [qResponsable, setQResponsable] = useState("");
    const [openEmpleado, setOpenEmpleado] = useState(false);
    const [openResponsable, setOpenResponsable] = useState(false);
    const empleadoRef = useRef(null);
    const responsableRef = useRef(null);
    const obtenerNombrePuesto = (idPuesto) => {
        const puesto = puestos.find(
            (p) =>
                Number(p.idpuesto) === Number(idPuesto)
        );

        return puesto?.nombrepuesto || "";
    };
    const seleccionarEmpleado = (empleado) => {
        const nombreCompleto =
            `${empleado.nombre} ${empleado.apellido}`.trim();

        const nombrePuesto = obtenerNombrePuesto(
            empleado.idpuesto
        );

        onChange({
            target: {
                name: "idempleado",
                value: empleado.idempleado,
            },
        });

        onChange({
            target: {
                name: "nombreEmpleado",
                value: nombreCompleto,
            },
        });

        onChange({
            target: {
                name: "puesto",
                value: nombrePuesto,
            },
        });

        setQEmpleado(nombreCompleto);
        setOpenEmpleado(false);
    };
    const seleccionarResponsable = (empleado) => {
        const nombreCompleto =
            `${empleado.nombre} ${empleado.apellido}`.trim();

        const nombrePuesto = obtenerNombrePuesto(
            empleado.idpuesto
        );

        onChange({
            target: {
                name: "nombreResponsable",
                value: nombreCompleto,
            },
        });

        onChange({
            target: {
                name: "cargoResponsable",
                value: nombrePuesto,
            },
        });

        setQResponsable(nombreCompleto);
        setOpenResponsable(false);
    };
    const empleadosFiltrados = empleados.filter((emp) => {
        const nombre =
            `${emp.nombre} ${emp.apellido}`.toLowerCase();

        return nombre.includes(
            qEmpleado.toLowerCase()
        );
    });

    const responsablesPermitidos = empleados.filter((emp) => {
        const puesto = puestos.find(
            (p) => Number(p.idpuesto) === Number(emp.idpuesto)
        );

        if (!puesto) return false;

        return puesto.nombrepuesto
            .toLowerCase()
            .includes("coordinación");
    });

    const responsablesFiltrados =
        responsablesPermitidos.filter((emp) => {
            const nombre =
                `${emp.nombre} ${emp.apellido}`.toLowerCase();

            return nombre.includes(
                qResponsable.toLowerCase()
            );
        });
    const fetchData = async () => {
        try {
            const [empleadosData, puestosData] =
                await Promise.all([
                    obtenerEmpleados(),
                    obtenerPuestos(),
                ]);

            setEmpleados(empleadosData);
            setPuestos(puestosData);
        } catch (error) {
            showToast(
                "Error al cargar empleados y puestos",
                "error"
            );
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                empleadoRef.current &&
                !empleadoRef.current.contains(event.target)
            ) {
                setOpenEmpleado(false);
            }

            if (
                responsableRef.current &&
                !responsableRef.current.contains(event.target)
            ) {
                setOpenResponsable(false);
            }
        };

        document.addEventListener(
            "mousedown",
            handleClickOutside
        );

        return () => {
            document.removeEventListener(
                "mousedown",
                handleClickOutside
            );
        };
    }, []);
    return (
        <div
            style={{
                flex: "0 0 30%",
                backgroundColor: "#f8f9fa",
                padding: "15px",
                overflow: "auto",
                borderLeft: "1px solid #e0e0e0",
            }}
        >
            <h2
                style={{
                    marginBottom: "10px",
                    color: "#000000",
                }}
            >
                Datos del Reconocimiento
            </h2>

            {/* Tipo de carta */}
            <div style={{ marginBottom: "15px" }}>
                <label
                    style={labelStyle}
                >
                    Tipo de reconocimiento
                </label>

                <select
                    value={tipoCarta}
                    onChange={(e) => setTipoCarta(e.target.value)}
                    style={selectStyle}
                >
                    <option value="institucional">
                        Carta Institucional de Reconocimiento
                    </option>

                    <option value="trayectoria">
                        Reconocimiento a la Trayectoria Institucional
                    </option>
                </select>
            </div>

            {/* ===================================== */}
            {/* CARTA DE TRAYECTORIA */}
            {/* ===================================== */}
            {tipoCarta === "trayectoria" && (
                <>
                    <h4 style={sectionTitleStyle}>Información del colaborador</h4>

                    <div
                        ref={empleadoRef}
                        style={{
                            position: "relative",
                            marginBottom: "15px",
                        }}
                    >
                        <label style={labelStyle}>
                            Nombre del Trabajador
                        </label>

                        <input
                            type="text"
                            value={qEmpleado}
                            placeholder="Buscar trabajador..."
                            onChange={(e) => {
                                setQEmpleado(e.target.value);
                                setOpenEmpleado(true);
                            }}
                            onFocus={() => setOpenEmpleado(true)}
                            style={inputStyle}
                        />

                        {openEmpleado &&
                            empleadosFiltrados.length > 0 && (
                                <div style={menuStyle}>
                                    {empleadosFiltrados.map((emp) => (
                                        <div
                                            key={emp.idempleado}
                                            style={menuItemStyle}
                                            onClick={() =>
                                                seleccionarEmpleado(emp)
                                            }
                                        >
                                            {emp.nombre} {emp.apellido}
                                        </div>
                                    ))}
                                </div>
                            )}
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                        <label style={labelStyle}>Puesto</label>
                        <input
                            type="text"
                            name="puesto"
                            value={data.puesto || ""}
                            readOnly
                            style={{
                                ...inputStyle,
                                backgroundColor: "#e9ecef",
                                cursor: "not-allowed",
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                        <label style={labelStyle}>Años de servicio</label>
                        <input
                            type="number"
                            name="aniosServicio"
                            value={data.aniosServicio}
                            onChange={onChange}
                            style={inputStyle}
                        />
                    </div>

                    <hr />

                    <h4 style={sectionTitleStyle}>Datos de emisión</h4>

                    <div style={{ marginBottom: "15px" }}>
                        <label style={labelStyle}>Ciudad</label>
                        <input
                            type="text"
                            name="ciudad"
                            value={data.ciudad}
                            onChange={onChange}
                            style={inputStyle}
                        />
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                        <label style={labelStyle}>Fecha</label>
                        <input
                            type="date"
                            name="fecha"
                            value={data.fecha || ""}
                            onChange={onChange}
                            style={inputStyle}
                        />
                    </div>

                    <hr />

                    <h4 style={sectionTitleStyle}>Firma</h4>

                    <div
                        ref={responsableRef}
                        style={{
                            position: "relative",
                            marginBottom: "15px",
                        }}
                    >
                        <label style={labelStyle}>
                            Nombre del responsable
                        </label>

                        <input
                            type="text"
                            value={qResponsable}
                            placeholder="Buscar responsable..."
                            onChange={(e) => {
                                setQResponsable(e.target.value);
                                setOpenResponsable(true);
                            }}
                            onFocus={() => setOpenResponsable(true)}
                            style={inputStyle}
                        />

                        {openResponsable &&
                            responsablesFiltrados.length > 0 && (
                                <div style={menuStyle}>
                                    {responsablesFiltrados.map((emp) => (
                                        <div
                                            key={emp.idempleado}
                                            style={menuItemStyle}
                                            onClick={() =>
                                                seleccionarResponsable(emp)
                                            }
                                        >
                                            {emp.nombre} {emp.apellido}
                                        </div>
                                    ))}
                                </div>
                            )}
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                        <label style={labelStyle}>Cargo del responsable</label>
                        <input
                            type="text"
                            name="cargoResponsable"
                            value={data.cargoResponsable}
                            onChange={onChange}
                            style={{
                                ...inputStyle,
                                backgroundColor: "#e9ecef",
                                cursor: "not-allowed",
                            }}
                            readOnly
                        />
                    </div>
                </>
            )}

            {/* ===================================== */}
            {/* CARTA INSTITUCIONAL */}
            {/* ===================================== */}
            {tipoCarta === "institucional" && (
                <>
                    <h4 style={sectionTitleStyle}>Información del colaborador</h4>

                    <div
                        ref={empleadoRef}
                        style={{
                            position: "relative",
                            marginBottom: "15px",
                        }}
                    >
                        <label style={labelStyle}>
                            Nombre del Trabajador
                        </label>

                        <input
                            type="text"
                            value={qEmpleado}
                            placeholder="Buscar trabajador..."
                            onChange={(e) => {
                                setQEmpleado(e.target.value);
                                setOpenEmpleado(true);
                            }}
                            onFocus={() => setOpenEmpleado(true)}
                            style={inputStyle}
                        />

                        {openEmpleado &&
                            empleadosFiltrados.length > 0 && (
                                <div style={menuStyle}>
                                    {empleadosFiltrados.map((emp) => (
                                        <div
                                            key={emp.idempleado}
                                            style={menuItemStyle}
                                            onClick={() =>
                                                seleccionarEmpleado(emp)
                                            }
                                        >
                                            {emp.nombre} {emp.apellido}
                                        </div>
                                    ))}
                                </div>
                            )}
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                        <label style={labelStyle}>Puesto</label>
                        <input
                            type="text"
                            name="puesto"
                            value={data.puesto || ""}
                            readOnly
                            style={{
                                ...inputStyle,
                                backgroundColor: "#e9ecef",
                                cursor: "not-allowed",
                            }}
                        />
                    </div>

                    <hr />

                    <h4 style={sectionTitleStyle}>Datos de emisión</h4>

                    <div style={{ marginBottom: "15px" }}>
                        <label style={labelStyle}>Lugar</label>
                        <input
                            type="text"
                            name="lugar"
                            value={data.lugar}
                            onChange={onChange}
                            style={inputStyle}
                        />
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                        <label style={labelStyle}>Fecha</label>
                        <input
                            type="date"
                            name="fecha"
                            value={data.fecha}
                            onChange={onChange}
                            style={inputStyle}
                        />
                    </div>

                    <hr />

                    <h4 style={sectionTitleStyle}>Motivos del reconocimiento</h4>

                    <textarea
                        name="motivosReconocimiento"
                        value={data.motivosReconocimiento || ""}
                        onChange={onChange}
                        rows={5}
                        placeholder={`LIDERAZGO Y RESPONSABILIDAD
TRABAJO COLABORATIVO
INICIATIVA Y PROACTIVIDAD`}
                        style={{
                            ...textareaStyle,
                            textTransform: "uppercase",
                        }}
                    />

                    {data.reconocimientos?.otro && (
                        <div style={{ marginTop: "10px" }}>
                            <input
                                type="text"
                                name="otroReconocimiento"
                                value={data.otroReconocimiento}
                                onChange={onChange}
                                placeholder="Especifique otro reconocimiento"
                                style={inputStyle}
                            />
                        </div>
                    )}

                    <hr />

                    <h4 style={sectionTitleStyle}>Descripción del reconocimiento</h4>

                    <textarea
                        name="descripcionReconocimiento"
                        value={data.descripcionReconocimiento}
                        onChange={onChange}
                        rows={6}
                        style={textareaStyle}
                    />

                    <hr />

                    <h4 style={sectionTitleStyle}>Firma</h4>

                    <div
                        ref={responsableRef}
                        style={{
                            position: "relative",
                            marginBottom: "15px",
                        }}
                    >
                        <label style={labelStyle}>
                            Nombre del responsable
                        </label>

                        <input
                            type="text"
                            value={qResponsable}
                            placeholder="Buscar responsable..."
                            onChange={(e) => {
                                setQResponsable(e.target.value);
                                setOpenResponsable(true);
                            }}
                            onFocus={() => setOpenResponsable(true)}
                            style={inputStyle}
                        />

                        {openResponsable &&
                            responsablesFiltrados.length > 0 && (
                                <div style={menuStyle}>
                                    {responsablesFiltrados.map((emp) => (
                                        <div
                                            key={emp.idempleado}
                                            style={menuItemStyle}
                                            onClick={() =>
                                                seleccionarResponsable(emp)
                                            }
                                        >
                                            {emp.nombre} {emp.apellido}
                                        </div>
                                    ))}
                                </div>
                            )}
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                        <label style={labelStyle}>Cargo del responsable</label>
                        <input
                            type="text"
                            name="cargoResponsable"
                            value={data.cargoResponsable}
                            onChange={onChange}
                            style={{
                                ...inputStyle,
                                backgroundColor: "#e9ecef",
                                cursor: "not-allowed",
                            }}
                            readOnly
                        />
                    </div>
                </>
            )}
            <button
                type="button"
                onClick={onPrint}
                disabled={generandoPDF}
                style={buttonPrimary}
            >
                {generandoPDF
                    ? "Generando PDF..."
                    : "Imprimir reconocimiento"}
            </button>
        </div>
    );
};

const labelStyle = {
    fontSize: "13px",
    fontWeight: "600",
    color: "#555",
    display: "block",
    marginBottom: "4px",
};

const inputStyle = {
    width: "100%",
    padding: "6px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "13px",
    backgroundColor: "#fff",
    boxSizing: "border-box",
};

const selectStyle = {
    ...inputStyle,
};

const textareaStyle = {
    ...inputStyle,
    resize: "vertical",
};

const sectionTitleStyle = {
    marginTop: "15px",
    marginBottom: "10px",
    color: "#000",
    fontSize: "15px",
    fontWeight: "600",
};

const buttonPrimary = {
    backgroundColor: "#023047",
    color: "#fff",
    width: "100%",
    padding: "10px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "600",
    marginTop: "15px",
};

const checkboxContainer = {
    marginBottom: "8px",
    fontSize: "13px",
    color: "#333",
};

const menuStyle = {
    position: "absolute",
    top: "100%",
    left: 0,
    width: "100%",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "6px",
    marginTop: "4px",
    maxHeight: "180px",
    overflowY: "auto",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    zIndex: 20,
};

const menuItemStyle = {
    padding: "8px",
    cursor: "pointer",
    fontSize: "13px",
};

export default ReconocimientoForm;